<template>
  <div>
    <label for="inputFeedCategory">Kategorie</label>
    <div class="input-group">
      <select
        id="inputFeedCategory"
        class="custom-select"
        aria-label="Kategorie auswählen"
        v-model="selected"
        :disabled="doNewCategory"
        required
        @change="changeCategory( { id: $event.target.value, name: '' })"
      >
        <optgroup class="text-muted bg-light" label="Kategorie">
          <option v-for="item in provider" :key="item.value" :value="item.value">{{item.name}}</option>
        </optgroup>
      </select>
      <div class="input-group-append">
        <button
          type="button"
          class="btn btn-outline-info"
          @click="showNewCategory"
          :disabled="doNewCategory"
        >
          <span class="fas fa-plus-circle"></span>
        </button>
      </div>
      <div class="invalid-feedback">Wähle eine Kategorie</div>
    </div>
    <div v-show="doNewCategory" class="form-group">
      <label class="pt-2" for="newUserCategory">Name der neuen Kategorie</label>
      <div class="d-flex">
        <input
          id="newCategory"
          class="form-control"
          aria-describedby="newUserCategory"
          placeholder="Meine Kategorie"
          required
          v-model="selected"
          @input="changeCategory( { id: '', name: $event.target.value })"
        >
        <button type="button" class="close p-2" aria-label="Close" @click="cancelNewCategory">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="invalid-feedback">Gib einen Namen an</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "User.Menu.SelectCategory",
  data: function() {
    return {
      selectedValue: "",
      doNewCategory: false
    };
  },
  props: {
    init: String
  },
  computed: {
    provider() {
      let provider = [];
      this.$store.state.UserFeeds.items.forEach(element => {
        provider.push({ name: element.name, value: element.id });
      });
      return provider;
    },
    selected: {
      // getter
      get: function() {
        if (this.selectedValue == "" && !this.doNewCategory ) return this.init;

        return this.selectedValue;
      },
      // setter
      set: function(newValue) {
        this.selectedValue = newValue;
      }
    }
  },
  methods: {
    showNewCategory: function() {
      this.doNewCategory = true;
      this.selectedValue = "";
      this.$nextTick(() => {
        document.getElementById("newCategory").focus();
      });
    },
    cancelNewCategory: function() {
      this.doNewCategory = false;
    },
    changeCategory: function(aCategory) {
      if (aCategory.id == "") {
        aCategory.id = aCategory.name.toLowerCase();
      }
      if (aCategory.name == "") {
        this.$store.state.UserFeeds.items.forEach(element => {
          if (element.id == aCategory.id) aCategory.name = element.name;
        });
      }

      this.$emit("changed", aCategory);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
